<template>
  <!-- 알림메일 상단 안내 문구 ("OOO 님" 아래 문단). 열 때 기본 문구가 채워져 있어 바로 고치면 됨. 비우면 서버의 기본 문구로 발송 -->
  <v-row dense class="mt-5">
    <v-col cols="12" class="pa-0 d-flex align-center">
      <label style="font-weight:bold;font-size:16px">{{ $t('emailtemp_intro') }}</label>
      <v-spacer/>
      <v-btn small text color="#4e6ef7" @click="$emit('input', defaulttext)">{{ $t('emailtemp_intro_default') }}</v-btn>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-textarea color="#4e6ef7" outlined rows="3" auto-grow persistent-hint
        :value="value" @input="$emit('input', $event)"
        :placeholder="defaulttext" :hint="$t('emailtemp_intro_hint')"
        />
    </v-col>
  </v-row>
</template>

<script>
import mailintro from '../assets/js/mailintro.js'

export default {
  props: {
    value: { type: String, default: '' },
    lan:   { type: Number, default: 0 },    //템플릿 언어 (0: 국문, 그 외: 영문)
  },
  computed: {
    defaulttext(){
      return mailintro.defaulttext(this.lan);
    },
  },
  //언어를 바꿨을 때 문구 교체는 각 화면의 언어 선택 칸 @change 에서 mailintro.changelan 으로 처리 (템플릿을 바꿔 열 때는 동작하지 않도록)
}
</script>
